export default __webpack_public_path__ + "static/310-9bb372290e422fb0734e15b502636dd0.jpg";